import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import timezone from 'dayjs/plugin/timezone.js';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

const BRAZIL_TIMEZONE = 'America/Sao_Paulo';

export const EMPTY_VALUE = 'Sem informação';

const priceFormatter = new Intl.NumberFormat('pt-br', {
  style: 'currency',
  currency: 'BRL',
});

export const formatPrice = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  const parsed = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(parsed)) {
    return '';
  }
  return priceFormatter.format(parsed);
};

export const formatDate = (dataString) => {
  if (!dataString) {
    return '';
  }

  try {
    const date = dayjs(dataString);

    if (!date.isValid()) {
      console.warn(`Invalid date provided to formatDate: ${dataString}`);
      return '';
    }

    return date.tz(BRAZIL_TIMEZONE).format('DD/MM/YYYY');
  } catch (error) {
    console.error(`Error formatting date: ${error.message}`);
    return '';
  }
};


export const formatExpectedOnDate = (dataString) => {
  if (!dataString) {
    return '';
  }

  try {
    const date = dayjs(dataString);

    if (!date.isValid()) {
      console.warn(`Invalid date provided to formatExpectedOnDate: ${dataString}`);
      return '';
    }

    // Convert to UTC and add 1 minute to get the correct date
    return date.utc().add(1, 'minute').format('DD/MM/YYYY');
  } catch (error) {
    console.error(`Error formatting expected_on date: ${error.message}`);
    return '';
  }
};

export const formatPhoneWithCountry = (countryCode, phoneNumber) => {
  const phone = (phoneNumber || '').toString().trim();
  if (!phone) {
    return '';
  }

  const dial = (countryCode || '').toString().trim();
  return dial ? `${dial} ${phone}` : phone;
};

export const formatDateTime = (dataString) => {
  if (!dataString) {
    return '';
  }

  try {
    const date = dayjs(dataString);
    
    if (!date.isValid()) {
      console.warn(`Invalid date provided to formatDateTime: ${dataString}`);
      return '';
    }

    return date.tz(BRAZIL_TIMEZONE).format('DD/MM/YYYY HH:mm');
  } catch (error) {
    console.error(`Error formatting datetime: ${error.message}`);
    return '';
  }
};